<div class="d-flex justify-content-center pt-2">
    <ngb-pagination
        class="d-flex justify-content-center"
        [(page)]="config.page"
        [collectionSize]="config.totalItems"
        [pageSize]="config.pageSize"
        [rotate]="config.isRotate || true"
        [size]="config.paginationSize"
        [maxSize]="config.maxSize || 5"
        [boundaryLinks]="config.isBoundaryLinks"
        (pageChange)="pageIndexChange.emit($event)"
    >
    </ngb-pagination>
</div>
